<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/purchaseInvoice/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item label="供应商" prop="supplierId">
          <el-select v-model="searchForm.supplierId" clearable filterable placeholder="请选择供应商">
            <el-option v-for="(item) of supplierArr" :value="item.userId" :label="item.userName"
              :key="item.userId"></el-option>
          </el-select> </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model.trim="searchForm.status" clearable filterable placeholder="请选择发货状态">
            <el-option v-for="(item, index) of statusArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="订单ID" prop="orderId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="提货ID" prop="deliveryId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="供应商" prop="supplierName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="发票金额" prop="invoiceAmount"></el-table-column>

        <el-table-column show-overflow-tooltip min-width="140" label="发票抬头" prop="invoiceTitle"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="发票类型" prop="invoiceType"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="状态" prop="status">
          <template v-slot="{ row }">
            <el-tag type="warning" v-if="row.status == '1'">未开</el-tag>
            <el-tag v-if="row.status == '2'">已开</el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="190">
          <template v-slot="{ row }">
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/purchaseInvoice/edit?invoiceId=' + row.invoiceId)">编辑</el-button>
            <el-button type="text"
              @click="$router.push('/purchaseInvoice/detail?invoiceId=' + row.invoiceId)">详情</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.invoiceId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'PurchaseInvoice',

  data () {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        supplierId: null,
        status: null

      },
      //
      statusArr: [
        {
          label: '未开',
          value: '1'
        },
        {
          label: '已开',
          value: '2'
        }
      ],
      supplierArr: []

    }
  },
  computed: {

    buttonList () {
      return this.$store.state.buttonList.map(item => item.butCode)
    },

    hasAdd () {
      return this.buttonList.includes('add')
    },

    hasEdit () {
      return this.buttonList.includes('edit')
    },

    hasDel () {
      return this.buttonList.includes('delete')
    }
  },
  created () {
    this.loadUser()
    this.loadData()
  },
  methods: {
    loadUser () {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.supplierArr = res || []
      })
      // this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '4' }).then(res => {
      //   this.supplierArr = res.list || []
      // })
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.purchaseInvoice.selectYcInvoiceByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        status: null,
        supplierId: null

      }
      this.loadOrder()
      this.onSearch()
    },

    deleteRow (invoiceId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseInvoice.deleteYcInvoice, {
          invoiceId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;

  .num {
    color: #007bff;
    margin-right: 15px;

  }
}
</style>
